var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47689 22H2.33036V8.64702H6.47689V22ZM4.40139 6.82555C3.07547 6.82555 2 5.72732 2 4.40139C2 3.7645 2.253 3.1537 2.70335 2.70335C3.1537 2.253 3.7645 2 4.40139 2C5.03828 2 5.64909 2.253 6.09943 2.70335C6.54978 3.1537 6.80279 3.7645 6.80279 4.40139C6.80279 5.72732 5.72687 6.82555 4.40139 6.82555ZM21.996 22H17.8584V15.4999C17.8584 13.9507 17.8271 11.9641 15.7025 11.9641C13.5467 11.9641 13.2163 13.6471 13.2163 15.3882V22H9.07427V8.64702H13.0511V10.4685H13.1092C13.6628 9.41936 15.015 8.31219 17.0325 8.31219C21.229 8.31219 22.0004 11.0756 22.0004 14.665V22H21.996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.62e902befaa22f0391110299588076f9.svg";
export { ForwardRef as ReactComponent };